var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 225 225",
    style: {
      enableBackground: "new 0 0 225 225"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000030469652807295385610000018405100446744692133_);}\n\t.st2{fill:url(#SVGID_00000008858699683487179390000012588416298286609343_);}\n\t.st3{fill:url(#SVGID_00000096746081127512143140000005322212894925728385_);}\n\t.st4{fill:url(#SVGID_00000109726773428225986510000010500493115593526433_);}\n\t.st5{fill:url(#SVGID_00000142161626485998565500000000320744543967881613_);}\n\t.st6{fill:url(#SVGID_00000039829948687968488980000005268623082146455202_);}\n\t.st7{fill:url(#SVGID_00000124873863053250552260000013414131072130596027_);}\n\t.st8{opacity:0.6;fill:url(#SVGID_00000117658255319374936310000008847953197985806766_);}\n\t.st9{fill:url(#SVGID_00000125590641247976358630000014678406472734778243_);}\n\t.st10{fill:url(#SVGID_00000134213484520955797220000018160841507782106523_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2869.3413,
    y1: 2484.2881,
    x2: 2785.7708,
    y2: 2402.5244,
    gradientTransform: "matrix(-1 0 0 -1 2921.3232 2502.2341)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29D7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1355,
    style: {
      stopColor: "#3DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4211,
    style: {
      stopColor: "#7083FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8298,
    style: {
      stopColor: "#C124FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9763,
    style: {
      stopColor: "#E000FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,54.8c0.6,11.6,8.1,22,18.9,26.2c5.6,2.2,11.4,2,17.3,1.9c6.5,0,12.9-0.1,19.4-0.1c1.1,0,2.1,0,3.2,0 c0.4,0,1.1,0.1,1.5,0c0.3-0.1,0.6-0.8,0.8-1.1c0.8-1.2,1.7-2.3,2.5-3.5c1.7-2.4,3.4-4.7,5.1-7.1c2.7-3.8,1.9-6.9,2.7-11.6 c0.3-1.4,0.2-4.1,0.3-5.6c0.1,1-0.8,9.9-0.8,10.9c0,2.8,0.4-1.1,0.4,1.7c0.1,9.3,0.6,17.7,0.7,27c0.1,11.2-0.1,22.4,0,33.7 c0.1,9.8-0.1,19.5,0,29.3c0.1,4.7-10.4,9.5-10.1,14.2c0,0.1,18,0.9,14.3,0.9c0.2-5.3,1.7-11.3,4.5-15.8c1-1.6,2.2-3.2,3.4-4.8 c2.4-3.3,4.8-6.6,7.1-9.9c3.4-4.8,6.9-9.5,10.3-14.3c6.7-9.3,13.5-18.7,20.2-28c5.7-8,11.5-15.9,17.2-23.9 c1.1-1.5,2.2-3.1,3.3-4.6c5-6.9,6.8-15.8,4.9-24.1c-2.1-8.8-8.2-16.4-16.4-20.2c-4.4-2-9-2.7-13.7-2.7c-7.7,0-15.3,0-23,0.1 c-11.8,0-23.7,0.1-35.5,0.1c-8.7,0-17.4,0.1-26,0.1c-2.8,0-5.5,0-8.3,0.5c-9.3,1.7-17.4,8.1-21.4,16.7 C37.5,45.2,36.6,50,36.8,54.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150076233412985244000000010639851452497246391_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.7547,
    y1: 127.8302,
    x2: 188.2453,
    y2: 127.8302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1481,
    style: {
      stopColor: "#FF00A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF2447"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150076233412985244000000010639851452497246391_)"
    },
    d: "M188.2,170.2c-0.6-11.6-8.1-22-18.9-26.2 c-4.7-1.8-9.6-2-14.5-2l0,0h-27.3l-0.1,0.1l-6.5,9c-0.8,1-1.5,2-2.1,3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.3-0.3,0.5 c-4.8,7.5-5.4,13.6-5.4,15.9l-4.5-116.6c-0.1,5.9-2,11.8-5.5,16.7l-8.9,12l0,0c-0.2,0.3-0.5,0.6-0.7,0.9 C90,88.5,86.5,93.3,83.1,98c-6.7,9.3-13.5,18.7-20.2,28c-5.7,8-11.5,15.9-17.2,23.9c-1.1,1.5-2.2,3.1-3.3,4.6 c-5,6.9-6.8,15.8-4.9,24.1c2.1,8.8,8.2,16.4,16.4,20.2c4.4,2,9,2.7,13.7,2.7c7.7,0,15.3,0,23-0.1c11.8,0,23.7-0.1,35.5-0.1 c8.7,0,17.4-0.1,26-0.1c2.8,0,9.1,0,11.9-0.5c9.3-1.7,17.4-8.1,21.4-16.7C187.5,179.8,188.4,175,188.2,170.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171718194949674644030000013919926660781774239_",
    gradientUnits: "userSpaceOnUse",
    x1: 1773.7136,
    y1: -1672.037,
    x2: 1772.3914,
    y2: -1580.2682,
    gradientTransform: "matrix(-9.310000e-02 -0.9957 0.9957 -9.310000e-02 1925.0586 1785.9047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#643C81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    style: {
      stopColor: "#AC96BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8211,
    style: {
      stopColor: "#E8E1EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171718194949674644030000013919926660781774239_)"
    },
    d: "M118.7,154.2c-6.5,9.1-7.4,21-2.3,30.9 c5.1,9.9,15.3,16.2,26.4,16.1l18.1-0.1c15.2-1.3,27-14.1,27-29.7c0-0.9,0-1.8-0.1-2.7c-1.4-15.1-14.1-26.9-29.6-26.9l-30.7,0.1 L118.7,154.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067930535961772535110000004231786706330042765_",
    gradientUnits: "userSpaceOnUse",
    x1: 3055.6821,
    y1: 2917.8496,
    x2: 3099.9912,
    y2: 3041.0713,
    gradientTransform: "matrix(1 0 0 1 -2954.998 -2820.2175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#942162"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4943,
    style: {
      stopColor: "#CC96B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    style: {
      stopColor: "#F1E1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067930535961772535110000004231786706330042765_)"
    },
    d: "M118.7,154.2c-6.5,9.1-7.4,21-2.3,30.9 c5.1,9.9,15.3,16.2,26.4,16.1l11.2-0.1c-46.8-15.7-26.5-59.2-26.5-59.2L118.7,154.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167385926939337609680000018279948569566927744_",
    gradientUnits: "userSpaceOnUse",
    x1: 3053.1663,
    y1: 2918.7502,
    x2: 3097.479,
    y2: 3041.9824,
    gradientTransform: "matrix(1 0 0 1 -2954.998 -2820.2175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#942162"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4943,
    style: {
      stopColor: "#CC96B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    style: {
      stopColor: "#F1E1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167385926939337609680000018279948569566927744_)"
    },
    d: "M142.8,201.3l4.8,0 c-0.6-0.2-1.2-0.4-1.8-0.6c-47.2-15.3-21.9-53.6-18.6-58.2l-8.5,11.7c-6.5,9.1-7.4,21-2.3,30.9 C121.5,195.1,131.7,201.3,142.8,201.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106113060474155997750000015445352749758848416_",
    gradientUnits: "userSpaceOnUse",
    x1: 1876.4641,
    y1: -1622.8004,
    x2: 1907.2506,
    y2: -1705.3345,
    gradientTransform: "matrix(-9.310000e-02 -0.9957 0.9957 -9.310000e-02 1925.0586 1785.9047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#513CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    style: {
      stopColor: "#A196FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8211,
    style: {
      stopColor: "#E5E1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106113060474155997750000015445352749758848416_)"
    },
    d: "M48.4,51.5c-1,16.3,11.3,30.4,27.5,31.5 l18.1-0.1l8.9-12c6.3-8.7,7.3-20.2,2.7-30c-4.6-9.7-14.1-16.2-24.7-16.9l-3.2-0.2C62.4,23.8,49.5,35.8,48.4,51.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123406195256380284980000002030461191112784559_",
    gradientUnits: "userSpaceOnUse",
    x1: 3117.0339,
    y1: 2965.9524,
    x2: 3020.9536,
    y2: 2835.5576,
    gradientTransform: "matrix(1 0 0 1 -2954.998 -2820.2175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#513CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    style: {
      stopColor: "#A196FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8211,
    style: {
      stopColor: "#E5E1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123406195256380284980000002030461191112784559_)"
    },
    d: "M94.1,82.8l8.9-12 c6.3-8.7,7.3-20.2,2.7-30c-4.6-9.7-14.1-16.2-24.7-16.9l-3.2-0.2c-4.2,0-8.3,0.9-11.9,2.6C115.8,47.4,97.5,77.8,94.1,82.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080171084256152897020000014452874415041676733_",
    gradientUnits: "userSpaceOnUse",
    x1: 3119.0037,
    y1: 2965.3838,
    x2: 3022.2317,
    y2: 2834.0505,
    gradientTransform: "matrix(1 0 0 1 -2954.998 -2820.2175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#513CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    style: {
      stopColor: "#A196FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8211,
    style: {
      stopColor: "#E5E1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080171084256152897020000014452874415041676733_)"
    },
    d: "M102.9,70.5c6.3-8.7,7.4-20.2,2.8-30 c-4.6-9.7-14.1-16.2-24.9-16.9l0,0c36,17.4,22.3,45.6,15.5,56L102.9,70.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103233162646551549760000009877260722192228250_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.1479,
    y1: 152.9658,
    x2: 102.8176,
    y2: 86.0803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    style: {
      stopColor: "#EBE1F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    style: {
      stopColor: "#B996DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6C21B0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000103233162646551549760000009877260722192228250_)"
    },
    d: "M108.5,54l4.7,119.7 c0,0-0.7-8.1,2.5-14.2c3.1-5.8,14.9-21.9,14.9-21.9L108.5,54z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128450146476034540790000004572020980293346966_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.7314,
    y1: 141.1239,
    x2: 101.9735,
    y2: 83.1396,
    gradientTransform: "matrix(1 -9.481865e-03 9.481865e-03 1 0.4825 -8.863650e-02)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1608,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2943,
    style: {
      stopColor: "#EBE1F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#B996DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6C21B0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000128450146476034540790000004572020980293346966_)"
    },
    points: "112.7,157.2 119.3,133.6  108.5,54.1 112.4,158.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030460116591499820360000013602705716495876270_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.9787,
    y1: 174.2124,
    x2: 110.9594,
    y2: 174.1459,
    gradientTransform: "matrix(1 -9.481865e-03 9.481865e-03 1 0.4825 -8.863650e-02)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    style: {
      stopColor: "#EBE1F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    style: {
      stopColor: "#B996DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6C21B0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030460116591499820360000013602705716495876270_)"
    },
    d: "M113.1,173c0,0.1,0,0.1,0,0.1L113.1,173z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7933bbc75ff6c5f685c2879ed35337ff.svg";
export { ForwardRef as ReactComponent };